import { TuitionFeeCheck } from '@/plugins/api'

export default {
  namespaced: true,
  state: {
    checks: [],
    count: [],
  },
  actions: {
    async fetch({ commit }, query) {
      const checks = await TuitionFeeCheck.fetch(query)
      commit('changeState', { checks: checks })
    },
    async count({ commit }, query) {
      const count = await TuitionFeeCheck.count(query)
      commit('changeState', { count: count })
    },
    fetchIndependent(_, params) {
      return TuitionFeeCheck.fetch(params)
    }
  },
  mutations: {},
  getters: {
    checks(state) {
      return state.checks
    },
  },
}
